export const fieldToParam = (field?: string): string | undefined =>
	field !== undefined ? field.toLowerCase() : undefined;

export const fieldFromParam = <
	V,
	O extends {
		[K: string]: V;
	},
>(
	map: O,
	param: string,
): V | undefined => (map[param] !== undefined ? map[param] : undefined);

export const trimSearchFilter = (searchFilter?: string): string | undefined => {
	if (searchFilter === undefined) {
		return undefined;
	}
	return searchFilter.trim() || undefined;
};
